export default {"src":"/_next/static/media/share.06120ef6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};